export default "__VITE_ASSET__CHQXDU41__"